module.exports = __webpack_public_path__ + "static/Premium_wyjatkowe_wew-9043f92b651363f47a49317f54e6d12c.png";